@if (courseDetail) {
  <pa-period-selection-grid
    [years]="courseDetail.courseYears"
    [periods]="periods"
    [availableSlots]="availableSlots"
    [showTimeslots]="true"
    [selectable]="isScheduleSelectable"
    (selectedPeriod)="clickOnPeriod($event)"
  />
}
